export const toPrice = (price: number | string) => {
  if (typeof price === "string") {
    price = Number(price);
  }
  return typeof price === "number" && !isNaN(price) ? price.toFixed(2) : "0.00";
};
